import React, { useEffect, useState } from "react";
import { API } from "./shared";

// Largest School vs Portfolio pillar gap, compared with the school's previous final comparison.
export const useLargestGapTrend = (pid, { tenantId, periodId } = {}) => {
  const [trends, setTrends] = useState({});
  useEffect(() => {
    if (!pid) return;
    const q = new URLSearchParams();
    if (tenantId) q.set("tenant_id", tenantId);
    if (periodId) q.set("period_id", periodId);
    fetch(`${API}/api/portfolio/${pid}/largest-gap-trend?${q}`, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : { trends: {} })).then((d) => setTrends(d.trends || {})).catch(() => setTrends({}));
  }, [pid, tenantId, periodId]);
  return trends;
};

const STYLE = {
  grew: "border-red-300 bg-red-50 text-red-800",
  shrank: "border-emerald-300 bg-emerald-50 text-emerald-800",
  steady: "border-slate-300 bg-slate-50 text-slate-700",
};

export const GapTrendBadge = ({ trend, testid }) => {
  if (!trend) return null;
  const n = Math.abs(trend.change).toFixed(1);
  const text = trend.direction === "grew" ? `▲ Gap grew ${n}` : trend.direction === "shrank" ? `▼ Gap shrank ${n}` : "Gap steady";
  const title = `Largest gap ${Math.abs(trend.current.gap).toFixed(1)} (${trend.current.pillar}, ${trend.current.period_name}) vs ${Math.abs(trend.previous.gap).toFixed(1)} (${trend.previous.pillar}, ${trend.previous.period_name})`;
  return (
    <span data-testid={testid} title={title}
      className={`inline-block whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-semibold ${STYLE[trend.direction]}`}>
      {text}
    </span>
  );
};
